import { observer } from 'mobx-react-lite'

import { Drawer, useGlobalCopyStore } from '../../common'

import { RecurringSettings } from './shared/RecurringSettings'

interface RecurringSettingsDrawerProps {
  isOpen: boolean
  onClose: () => void
  selectedTab?: number
}

export const RecurringSettingsDrawer = observer(
  ({ isOpen, onClose, selectedTab }: RecurringSettingsDrawerProps) => {
    const { cashflow: copy } = useGlobalCopyStore()

    return (
      <Drawer
        ariaLabelClose={copy.close_settings_aria}
        isOpen={isOpen}
        onClose={onClose}
        title={copy.cashflow_settings}
      >
        <RecurringSettings defaultSelectedTab={selectedTab} />
      </Drawer>
    )
  },
)
